import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  alias: "",
  domain: "",
  name: "",
  integrations: {},
  accounts: [],
  templates: [],
  activeTemplate: null,
  sequences: [],
  activeSequence: null,
  activeTask: null,
};

export const companies = createSlice({
  name: "companies",
  initialState,
  reducers: {
    updateCompany: (state, { payload }) => {
      state.alias = payload.companyAlias;
      state.domain = payload.domain;
      state.name = payload.name;
      state.integrations = payload.integrations;
    },
    updateAccounts: (state, { payload }) => {
      state.accounts = payload;
    },
    updateActiveTemplate: (state, { payload }) => {
      state.activeTemplate = payload;
    },
    updateTemplates: (state, { payload }) => {
      state.templates = payload;
    },
    updateActiveSequence: (state, { payload }) => {
      state.activeSequence = payload;
    },
    updateActiveTask: (state, { payload }) => {
      state.activeTask = payload;
    },
    resetCompanies: (state) => {
      state.alias = initialState.alias;
      state.domain = initialState.domain;
      state.name = initialState.name;
    },
  },
});

export const companiesReducers = companies.actions;

export default companies.reducer;
